import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import auth from './modules/auth'
import user from './modules/user'
import mission from './modules/mission'
import workspace from './modules/workspace'
import macro from './modules/macro'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    user,
    mission,
    workspace,
    macro,
  },
  plugins: [
    createPersistedState({
      paths: ['auth.user', 'auth.isLoggedIn'],
    }),
  ],
})
